import { MeshProps } from '@react-three/fiber'
import { frontBar } from '../helper/verandaDimensions'
import { useMeasures } from '../../../../../hooks/state/useMeasures'
import { useRoof } from '../../../../../hooks/state/useRoof'
import { Helper } from '../../../../../classes/helper'
import { Shape } from 'three'
import { detachedBar } from '../helper/verandaDimensions'
import { CachedMeshPhysicalMaterial } from '../../../../material/cachedMeshPhysicalMaterial'
interface Props extends MeshProps {
  logBarHeight: number
  rotate?: number
}

export const LogsBarClassic = ({
  position,
  logBarHeight,
  rotate = 0,
}: Props): JSX.Element => {
  const { verandaTyp } = useMeasures()
  const { color } = useRoof()
  const depth = verandaTyp.log.depth
  const width = verandaTyp.log.width
  const radius = 0.025

  const shape = new Shape()
    .moveTo(0, 0)
    .lineTo(depth - radius, 0)
    .quadraticCurveTo(depth, 0, depth, radius)
    .lineTo(depth, width - radius)
    .quadraticCurveTo(depth, width, depth - radius, width)
    .lineTo(0, width)

  const extrudeSettings = {
    steps: 1,
    depth: logBarHeight,
    curveSegments: 16 * 2,
    bevelEnabled: false,
  }

  return (
    <mesh
      position={position}
      rotation={[
        Helper.convertAngleToRadiant(90),
        0,
        Helper.convertAngleToRadiant(90),
      ]}
      castShadow={true}
    >
      <extrudeGeometry attach="geometry" args={[shape, extrudeSettings]} />
      <CachedMeshPhysicalMaterial color={color} />
    </mesh>
  )
}
